import React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
// import { dueDateMethodTypeServices } from 'src/services/reservation/dueDateMethodType/DueDateMethodType.service'
// import { productTypeServices } from 'src/services/reservation/product-type/product_type.service'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()
  const typeDeterminationOptions = [
    {id:'autocancel_date', label:translate('ra.field.autocancel_date')},
    {id:'date_in', label:translate('ra.field.date_origin_service')},
    {id:'date_out', label:translate('ra.field.date_destination_service')},
    {id:'issuance_datetime', label:translate('ra.field.date_emision')},
    {id:'created_at', label:translate('ra.field.created_at')},
    {id:'cancel_info', label:translate('ra.field.supplier_expense_date')}
  ]
  // useEffect(() => {
  //   ;(async () => {
  //     await Promise.all([
  //       getDueDateMethodTypes(),
  //       getProductTypes()
  //     ])
  //   })()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // const getDueDateMethodTypes = async () => {
  //   try {
  //     const allDueDateMethodTypes = await dueDateMethodTypeServices.getByAll({ limit: 999 })
  //     setDueDateMethodTypeList(allDueDateMethodTypes)
  //   } catch (error) {
  //     setDueDateMethodTypeList([])
  //   }
  // }

  // const getProductTypes = async () => {
  //   try {
  //     const allProducts = await productTypeServices.getByParam()
  //     setProductTypeList(allProducts)
  //   } catch (error) {
  //     setProductTypeList([])
  //   }
  // }

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.entity.due-date-method')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.name')} value={record.name} />
          <ShowListElement label={translate('ra.field.due-date-range')} value={record?.due_date_range?.name} />
          <ShowListElement label={translate('ra.field.type_determination_date')} value={typeDeterminationOptions.find(option=>option.id === record?.type_determination_date)?.label ?? ''} />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const DueDateMethodShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}